module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/chowbus_logo_white-d2fa31390e1752f39e5086b0e4e89b07.png";